import { useNavigate } from "react-router-dom";
import { LogIn, LogOut, ShieldAlert } from "lucide-react";

const wrap = "ti-dark -m-3 min-h-[calc(100vh-3rem)] w-full max-w-full overflow-x-hidden px-4 py-6 pb-28 sm:-m-5 sm:px-6 lg:-m-5 lg:-mb-5 lg:px-8 lg:py-6 lg:pb-6";

export default function SecurityPos() {
  const nav = useNavigate();
  return (
    <div className={wrap} data-testid="security-pos-page">
      <div className="mx-auto w-full min-w-0 max-w-md">
        <div className="mb-6 flex items-center gap-2.5">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-500/12 text-blue-300 ring-1 ring-inset ring-blue-400/30"><ShieldAlert size={22} /></span>
          <div><h1 className="font-heading text-xl font-extrabold text-white">Pos Security</h1><p className="text-[11px] text-[#AAB8CC]">Catat pergerakan kendaraan</p></div>
        </div>
        <div className="grid gap-4">
          <button data-testid="btn-unit-masuk" onClick={() => nav("/security/masuk")} className="flex min-w-0 flex-col items-center justify-center gap-3 rounded-2xl border border-emerald-400/30 bg-emerald-500/10 py-10 text-emerald-200 transition-transform active:scale-[0.98]">
            <LogIn size={40} /><span className="text-2xl font-extrabold tracking-wide">UNIT MASUK</span>
          </button>
          <button data-testid="btn-unit-keluar" onClick={() => nav("/security/keluar")} className="flex min-w-0 flex-col items-center justify-center gap-3 rounded-2xl border border-blue-400/30 bg-blue-500/10 py-10 text-blue-200 transition-transform active:scale-[0.98]">
            <LogOut size={40} /><span className="text-2xl font-extrabold tracking-wide">UNIT KELUAR</span>
          </button>
        </div>
      </div>
    </div>
  );
}
